class AutomaticFiring {
    name;
    shortName;
    /**
     * Logic for automatic gun firing.
     */
    constructor() {
        this.name = "Automatic";
        this.shortName = "auto";
    }
    /** No-op */
    onShoot() { }
    /** No-op */
    onStopShooting() { }
    /**
     * Check whether the gun can fire.
     * @returns true.
     */
    get canFire() {
        return true;
    }
    get getShortName() {
        return this.shortName;
    }
    get getName() {
        return this.name;
    }
}
export { AutomaticFiring };
